export default __webpack_public_path__ + "ddf5134102e35edf701308a05ffc5515.jpg";